"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpArrow = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const UpArrow = ({
  size = 16,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.911 11.0303C13.2038 11.3232 13.6787 11.3232 13.9716 11.0303C14.2645 10.7374 14.2645 10.2626 13.9716 9.96967L12.911 11.0303ZM8.47165 4.46971C8.17876 4.17681 7.70388 4.17681 7.41099 4.46971C7.1181 4.7626 7.1181 5.23748 7.41099 5.53037L8.47165 4.46971ZM13.9716 9.96967L8.47165 4.46971L7.41099 5.53037L12.911 11.0303L13.9716 9.96967Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M1.96968 9.91095C1.67678 10.2038 1.67677 10.6787 1.96966 10.9716C2.26255 11.2645 2.73743 11.2645 3.03032 10.9716L1.96968 9.91095ZM8.47196 5.53011C8.76486 5.23722 8.76486 4.76234 8.47197 4.46945C8.17908 4.17655 7.70421 4.17654 7.41131 4.46943L8.47196 5.53011ZM3.03032 10.9716L8.47196 5.53011L7.41131 4.46943L1.96968 9.91095L3.03032 10.9716Z",
  fill: "#121213"
}));

exports.UpArrow = UpArrow;